import React from 'react';
import { BuyCreditsModal as SharedBuyCreditsModal, createCreditCheckoutViaSupabase } from '@rehub/buy-credits';
import { supabase, isConfigured } from '../services/supabase';
import type { UserProfile } from '../types';

interface CreditsModalProps {
  user: UserProfile;
  onClose: () => void;
  onSuccess?: () => void;
}

const CreditsModal: React.FC<CreditsModalProps> = ({ user, onClose }) => (
  <SharedBuyCreditsModal
    userId={user.id}
    credits={user.credits ?? 0}
    onClose={onClose}
    appSource="hdrphoto"
    accent="orange"
    createCheckout={async (params) => {
      if (!isConfigured) throw new Error('Payment system not available.');
      return createCreditCheckoutViaSupabase(supabase, params);
    }}
    footerNote={
      <p className="text-[11px] text-slate-400">
        ReHub Credits are for PhotoClear, staging, HyperDusk and ImageMotion. HDR processing uses HDR Credits — 10 free edits every month.
      </p>
    }
  />
);

export default CreditsModal;
